import {BANNER_CONDITIONS} from "@/enums/banner";
import {GailProductRoles} from "@/enums/user";
import {IconName} from "@fortawesome/fontawesome-common-types";
import {LangString} from "../api";

export enum SITES {
   MARKETING = "marketing",
   DASHBOARD = "dashboard",
   DASHBOARD_PUBLIC = "dashboard_public",
}

export type BannerLink = {
   type: "url" | "id";
   value: string;
   text: LangString;
};

export type BannerVariant = "default" | "primary";

export type BannerItemCreate = {
   sites: SITES[];
   icon?: IconName;
   description: LangString;
   status: "success" | "error" | "warning" | "info";
   isPersistent: boolean;
   variant?: BannerVariant;
   links?: BannerLink[];
   /** @deprecated Use `links` instead */
   link?: string;
   /** @deprecated Use `links` instead */
   linkAction?: () => void;
   /** @deprecated Use `links` instead */
   linkText?: LangString;
   /** @deprecated Use `links` instead */
   linkId?: string;
   condition?: BANNER_CONDITIONS;
   products?: GailProductRoles[];
   startDate?: string;
   endDate?: string;
};

export type BannerItem = {
   id: string;
   sites: SITES[];
   icon?: IconName;
   description: LangString;
   status: "success" | "error" | "warning" | "info";
   isPersistent: boolean;
   createdAt: string;
   updatedAt: string;
   variant?: BannerVariant;
   links?: BannerLink[];
   /** @deprecated Use `links` instead */
   link?: string;
   /** @deprecated Use `links` instead */
   linkAction?: () => void;
   /** @deprecated Use `links` instead */
   linkText?: LangString;
   /** @deprecated Use `links` instead */
   linkId?: string;
   condition?: BANNER_CONDITIONS;
   products?: GailProductRoles[];
   startDate?: string;
   endDate?: string;
};
